import React, { useState } from 'react';
// import './Gallery.css';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch'
import { BASE_URL } from '../../../constant'
import '../../../sass/gallery.scss'

const Gallery = ({ images, thumbnail, slug, title }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  // const mainRef = useRef(null);
  // const modalRef = useRef(null);

  const handleThumbnailPress = (index) => {
    setCurrentIndex(index);
  };

  const renderThumbnail = (item, index) => (
    <div 
      key={index} 
      className={`thumbnail ${currentIndex === index ? 'active' : ''}`} 
      onClick={() => handleThumbnailPress(index)}
    >
      <img src={BASE_URL+item.path} alt="thumbnail" />
    </div>
  );

  return (
    <div className="gallery-container">
      <div className="main-image" onClick={() => setModalVisible(true)}>
        <img src={images?.length > 0 ? BASE_URL+images[currentIndex].path : BASE_URL+thumbnail} alt="main" />
      </div>

      <div className="thumbnail-container">
        {images?.length > 0 ? images.map(renderThumbnail) : renderThumbnail({ path: thumbnail }, 0)}
      </div>

      {modalVisible && (
        <div className="modal-overlay" onClick={() => setModalVisible(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <TransformWrapper>
              <TransformComponent>
                <img width={500} height={500} src={images?.length > 0 ? BASE_URL+images[currentIndex].path : BASE_URL+thumbnail} alt="Zoomed" />
              </TransformComponent>
            </TransformWrapper>
            <div className="modal-thumbnails" style={{ display: "flex" }}>
              {images?.length > 0 ? images.map(renderThumbnail) : renderThumbnail({ path: thumbnail }, 0)}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;